(function() {
  angular
    .module('cfn')
    .factory('cropSequenceCoreDataResolver', cropSequenceCoreDataResolver);

  cropSequenceCoreDataResolver.$inject = ['CropSequence'];
  // resolve function bef
  function cropSequenceCoreDataResolver(CropSequence) {
    return function() {
      return coreCommonResolveFunction(CropSequence, true);
    };
  }
})();
